import { createSlice } from '@reduxjs/toolkit'
import {
    LogsList,
} from './thunk'
//import _ from 'lodash'

export const initialState = {
    data: [],
    loading: true
}

const logsSlice = createSlice({
    name: 'logslist',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(LogsList.pending, (state) => {
            state.loading = true
        })
        builder.addCase(LogsList.fulfilled, (state, action) => {
            const data = action.payload?.data || action.payload || []
            state.data = data
            state.loading = false
        })
        builder.addCase(LogsList.rejected, (state) => {
            state.loading = false
        })
    }
})

export default logsSlice.reducer